import React, {useEffect, useState} from 'react'
import {Box, Flex, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {useIntl, FormattedMessage} from 'react-intl'
import Search from '../../components/search'
import ProductRegistrationImageContainer from './partials/product-registration-image-container'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import routingObject from '../../utils/static-routes'
import ProductRegistrationHeader from './partials/product-registration-header'
import ProductRegistrationStepper from './partials/product-registration-stepper'
import {Helmet} from 'react-helmet'
import {useProductRegistrationData} from '../../custom-hooks/use-product-registration-data'

const ProductSearch = () => {
    const styles = useMultiStyleConfig('ProductRegistration', {variant: 'productSearch'})
    const [searchResults, setSearchResults] = useState([])
    const [suggestionRegistration, setSuggestionRegistration] = useState([])
    const [productSelect, setProductSelect] = useState('')
    const navigate = useNavigation()

    const {
        skuImage,
        modelNumberImage,
        skuTitle,
        skuDescription,
        modelTitle,
        modelDescription,
        webPageSchemaMarkup,
    } = useProductRegistrationData()

    const SearchBar = (props) => {
        const intl = useIntl()
        const placeholder = intl.formatMessage({
            id: 'product_registration.search',
            defaultMessage: 'Search by SKU or Model Number',
        })
        return (
            <Search
                ariaLabel={placeholder}
                searchInputPlaceholder={placeholder}
                variant={'productSearch'}
                setSearchResults={setSearchResults}
                isProductRegistration
                setProductSelect={setProductSelect}
                setSuggestionRegistration={setSuggestionRegistration}
                shouldRemoveLabel
                showSpellingMessage={
                    searchResults?.hits === undefined &&
                    searchResults?.length !== 0 &&
                    !suggestionRegistration?.productId
                }
                {...props}
            />
        )
    }

    useEffect(() => {
        if (
            (searchResults &&
                productSelect.length !== 0 &&
                searchResults?.hits !== undefined &&
                searchResults?.length !== 0) ||
            (suggestionRegistration?.productId && searchResults && productSelect)
        ) {
            navigate(
                `${routingObject.PRODUCT_REGISTRATION_PATH}/select?text=` +
                    productSelect.replaceAll(' ', '-'),
            )
        }
    }, [searchResults, productSelect, suggestionRegistration])

    return (
        <Flex {...styles.container} layerStyle={'page'}>
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(webPageSchemaMarkup, null, 2)}
                </script>
            </Helmet>
            <Flex {...styles.headerStepperContainer}>
                <ProductRegistrationHeader index={1} variant={'product'} />
                <ProductRegistrationStepper index={1} />
            </Flex>
            <Flex {...styles.bottomContainer}>
                <Flex {...styles.labelSearchOuterContainer}>
                    <Flex {...styles.labelSearchInnerContainer}>
                        <Text {...styles.labelSearchTitle}>
                            <FormattedMessage
                                id="product_registration.enter_sku_or_model"
                                defaultMessage="Enter the SKU code or Model Number of your product"
                            />
                        </Text>
                        <Text {...styles.labelSearchDescription}>
                            <FormattedMessage
                                id="product_registration.no_sku_enter_model"
                                defaultMessage="Don't have the SKU code? Enter the Model Number of the product you want to register."
                            />
                        </Text>
                        <Box {...styles.searchBarOuterContainer}>
                            <Box {...styles.searchBarContainer}>
                                <SearchBar />
                            </Box>
                            <Text {...styles.exampleLabel}>
                                <FormattedMessage
                                    id="product_registration.sku_examples"
                                    defaultMessage="Examples of valid SKU codes: <i>0W22234994007, 0W22234994007, 0W22234994007</i>"
                                    values={{
                                        i: (chunks) => <i>{chunks}</i>,
                                    }}
                                />
                            </Text>
                            <Text {...styles.exampleLabel}>
                                <FormattedMessage
                                    id="product_registration.model_examples"
                                    defaultMessage="Examples of valid Model Numbers: <i>EXAM.000.999.009, EXAM.000.999.009</i>"
                                    values={{
                                        i: (chunks) => <i>{chunks}</i>,
                                    }}
                                />
                            </Text>
                        </Box>
                    </Flex>
                </Flex>
                <Flex {...styles.infoBannerBox}>
                    <ProductRegistrationImageContainer
                        image={skuImage}
                        title={skuTitle}
                        description={skuDescription}
                        variant="productSearch"
                    />
                    <ProductRegistrationImageContainer
                        image={modelNumberImage}
                        title={modelTitle}
                        description={modelDescription}
                        variant="productSearch"
                    />
                </Flex>
            </Flex>
        </Flex>
    )
}

export default ProductSearch
